import { render, staticRenderFns, recyclableRender, components } from "./payment-password.vue?vue&type=template&id=13d32a74&scoped=true&"
var renderjs
import script from "./payment-password.vue?vue&type=script&lang=js&"
export * from "./payment-password.vue?vue&type=script&lang=js&"
import style0 from "./payment-password.vue?vue&type=style&index=0&id=13d32a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d32a74",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/setting/payment-password.vue"
export default component.exports